// --- HELPER: Format price for CA market ---
function formatPriceForMarket(price) {
    if (!price) return price;
    var isCA = (window.Shopify && window.Shopify.country && window.Shopify.country === 'CA') ||
               window.location.pathname.indexOf('/en-ca') !== -1;
    if (isCA) {
        // Idempotent: if the value is already formatted (e.g. the Liquid-rendered
        // "810 $CA" used as a fallback when data-*-price attrs are missing), return it
        // as-is. Otherwise replace('$','') would strip the $ out of "$CA" and re-append
        // " $CA", mutating the text on every pass — which makes updateChillerPrices'
        // guard never match, so it writes endlessly and the subtree MutationObserver
        // re-fires forever → OOM crash on CA. See chiller price loop fix.
        if (price.indexOf('$CA') !== -1) return price;
        return price.replace('$', '') + ' $CA';
    }
    return price;
}

/**
 * Función auxiliar para actualizar los precios de los Chiller. (TU CÓDIGO)
 * Lee los precios con y sin Wi-Fi de los atributos data- en los inputs de radio.
 * @param {boolean} isWifiActive - Verdadero si el switch de Wi-Fi está activo.
 */
function updateChillerPrices(isWifiActive) {
    // 🔥 CORRECCIÓN: Usamos el selector de 'comienza con' (name^=) para ignorar espacios o saltos de línea.
    // Asegúrate de que "Water Chiller-1" sea la parte inicial del nombre real.
    const chillerInputs = document.querySelectorAll('input[name^="Water Chiller-1"]');
    if (chillerInputs.length === 0) {
        return;
    }

    chillerInputs.forEach(input => {
        // 1. Encontrar la etiqueta <label> asociada al input.
        const label = document.querySelector(`label[for="${input.id}"]`);
        if (!label) {
            return;
        }

        // 2. Encontrar el elemento de precio.
        const priceElement = label.querySelector('.option-label-details-price-new');
        const oldPriceElement = label.querySelector('.option-label-details-price-old');
        if (!priceElement) {
            return;
        }
        // 3. Obtener los precios de los atributos data-.
        const basePrice = input.dataset.nowifiPrice;
        const wifiPrice = input.dataset.wifiPrice;

        let newPrice = '';

        if (isWifiActive && wifiPrice) {
            newPrice = wifiPrice;
        } else if (basePrice) {
            // Se usa el precio base si el Wi-Fi está inactivo o si el precio Wi-Fi no existe.
            newPrice = basePrice;
        } else {
            // Usar el precio actual si no hay datos de respaldo para evitar dejarlo en blanco.
            newPrice = priceElement.textContent;
            console.warn(`[PRECIOS] ⚠️ Advertencia: Faltan data-attributes (wifi/base) en el input ID: ${input.id}. Usando precio actual.`);
        }
        newPrice = formatPriceForMarket(newPrice);

        // 4. Actualizar el contenido de texto.
        if (newPrice && priceElement.textContent !== newPrice) {
            priceElement.textContent = newPrice;
        } else if (priceElement.textContent === newPrice) {}

        // 5. Actualizar el precio tachado (old price).
        if (oldPriceElement) {
            const baseOldPrice = input.dataset.nowifiPriceOld;
            const wifiOldPrice = input.dataset.wifiPriceOld;
            let newOldPrice = '';
            if (isWifiActive && wifiOldPrice) {
                newOldPrice = wifiOldPrice;
            } else if (baseOldPrice) {
                newOldPrice = baseOldPrice;
            }
            newOldPrice = formatPriceForMarket(newOldPrice);
            if (newOldPrice && oldPriceElement.textContent !== newOldPrice) {
                oldPriceElement.textContent = newOldPrice;
            }
        }
    });
}


// --- NUEVA FUNCIÓN AÑADIDA: LÓGICA DE PROTECCIÓN ---
function updateProtectionPrice() {
    const PROTECTION_FIELDSET_CLASS = ".custom_chooseprotection";
    const STATE_INPUT_ID = "#chillerselected";
    const CHILLER_RADIO_SELECTOR = 'input[name^="Water Chiller-1"]';
    const baseProtectionText = "5- Year";

    // ⭐ Mantenidos los precios originales y añadida la regla para "No Chiller"
    const priceMap = {
        "1/3HP": " +$99",
        "1/2HP": " +$149",
        "1HP": " +$199",
        "No Chiller": " +$99" // 👈 REGLA PARA "NO CHILLER"
    };

    const stateInput = document.querySelector(STATE_INPUT_ID);
    let selectedChillerValue = stateInput ? stateInput.value : null;

    if (!selectedChillerValue) return;

    // Obtener elementos de la protección
    const currentProtectionFieldset = document.querySelector(PROTECTION_FIELDSET_CLASS);
    // Asumiendo que el input de 5-Year tiene un valor que contiene "5- Year"
    const protectionInput = currentProtectionFieldset ? currentProtectionFieldset.querySelector('input[value*="5- Year"]') : null;
    if (!protectionInput) return;

    const protection5YearLabel = protectionInput.nextElementSibling;
    const protection5YearVariantName = protection5YearLabel ? protection5YearLabel.querySelector('.variant-name') : null;
    if (!protection5YearVariantName) return;

    let priceSuffix = "";

    // 🔍 Lógica para determinar el sufijo de precio
    if (selectedChillerValue === "No Chiller") { // 👈 Comprobación exacta para "No Chiller"
        priceSuffix = priceMap["No Chiller"];
    } else if (selectedChillerValue.includes("1/3HP")) {
        priceSuffix = priceMap["1/3HP"];
    } else if (selectedChillerValue.includes("1/2HP")) {
        priceSuffix = priceMap["1/2HP"];
    } else if (selectedChillerValue.includes("1HP")) {
        priceSuffix = priceMap["1HP"];
    } else {
        // En caso de que el valor no coincida con nada, no se agrega sufijo.
        priceSuffix = "";
    }

    const newVisibleText = baseProtectionText + priceSuffix;

    // Aplicar SOLO el cambio de texto visible (EVITANDO EL BUCLE)
    if (protection5YearVariantName.textContent.trim() !== newVisibleText.trim()) {
        protection5YearVariantName.textContent = newVisibleText;
    }
}
// ---------------------------------------------------------------------

/**
 * Función que maneja la lógica de click y estado del switch. (TU CÓDIGO MODIFICADO)
 */
function handleSwitchLogic(switchButton, wifiInput, withoutWifiInput, switchContainer) {
    function handleSwitchClick(event) {
        const clickedElement = event.target.closest('#my-switch, .switch-label');
        if (!clickedElement) return;

        if (event.target.closest('.tooltip-icon')) {
            return;
        }

        event.stopPropagation();
        event.preventDefault();

        let isWifiChecked = switchContainer.classList.contains('is-active');

        switchContainer.classList.toggle('debug-clicked');
        if (isWifiChecked) {
            // CAMBIANDO A SIN WIFI (OFF)
            if (withoutWifiInput.checked !== true) {
                withoutWifiInput.checked = true;
                withoutWifiInput.dispatchEvent(new Event('change', {
                    bubbles: true
                }));
            }
            switchContainer.classList.remove('is-active');
            // 🔥 ACTUALIZAR PRECIOS A MODO SIN WIFI
            updateChillerPrices(false);

            // ⭐ AÑADIDO: Vuelve a aplicar el precio de protección
            updateProtectionPrice();

        } else {
            // CAMBIANDO A CON WIFI (ON)
            if (wifiInput.checked !== true) {
                wifiInput.checked = true;
                wifiInput.dispatchEvent(new Event('change', {
                    bubbles: true
                }));
            }
            switchContainer.classList.add('is-active');
            // 🔥 ACTUALIZAR PRECIOS A MODO CON WIFI
            updateChillerPrices(true);

            // ⭐ AÑADIDO: Vuelve a aplicar el precio de protección
            updateProtectionPrice();
        }
    }

    // --- Lógica de Inicialización ---

    if (switchContainer.hasAttribute('data-delegated-listener')) {
        let isCheckedInitial = wifiInput.checked;
        switchContainer.classList.toggle('is-active', isCheckedInitial);
        // 🔥 Inicializar precios según el estado actual del switch
        updateChillerPrices(isCheckedInitial);
        // ⭐ AÑADIDO: Inicializar la protección en esta rama
        updateProtectionPrice();

        return;
    }

    switchContainer.addEventListener('click', handleSwitchClick);
    switchContainer.setAttribute('data-delegated-listener', 'true');

    let isCheckedInitial = wifiInput.checked;
    switchContainer.classList.toggle('is-active', isCheckedInitial);
    // 🔥 Inicializar precios en la primera ejecución
    updateChillerPrices(isCheckedInitial);
    // ⭐ AÑADIDO: Inicializar la protección en esta rama
    updateProtectionPrice();
}


function initializeWifiSwitchController() {
    const productInfoContainer = document.querySelector('.product__info-container');
    if (!productInfoContainer) {
        console.error('[INICIO] 🛑 Contenedor ".product__info-container" no encontrado.');
        return;
    }

    function findAndApplyLogic() {
        const switchButton = document.getElementById('my-switch');
        const switchContainer = switchButton ? switchButton.closest('.switch-container') : null;
        // Prefix match handles both spacing variants of each name
        // (e.g. "Yes WiFi+UV Sanitation" AND "Yes WiFi + UV Sanitation").
        const wifiInput = document.querySelector('input[type="radio"][value^="Yes WiFi"], input[type="radio"][value^="Yes App Controlled"]');
        const withoutWifiInput = document.querySelector('input[type="radio"][value^="No WiFi"], input[type="radio"][value^="No App Controlled"]');

        if (!switchButton || !switchContainer || !wifiInput || !withoutWifiInput) {
            console.warn('[INICIO] ⚠️ Elementos clave (switch/inputs Yes/No) no encontrados. Reintentando en carga dinámica.');
            return;
        }
        handleSwitchLogic(switchButton, wifiInput, withoutWifiInput, switchContainer);
        // ⭐ AÑADIDO: Asegurar que la protección se aplica después de la lógica de inicialización/carga
        updateProtectionPrice();
    }

    findAndApplyLogic();

    // Lógica para detectar carga dinámica (Shopify AJAX)
    const observer = new MutationObserver((mutationsList, observer) => {
        findAndApplyLogic();
    });

    observer.observe(productInfoContainer, {
        childList: true,
        subtree: true
    });
    document.addEventListener('shopify:section:load', findAndApplyLogic);
    // ⭐ AÑADIDO: Asegurar que la protección se aplica después de la lógica de inicialización/carga
    updateProtectionPrice();
}

document.addEventListener('DOMContentLoaded', initializeWifiSwitchController);
// observeChillerSelection();
